module.exports = __webpack_public_path__ + "img/printer.843d7eca.png";